import create from "zustand";

export type TalhaoStore = {
  id: string;
  ocupacao: string;
}

export type TalhaoState = {
  allTalhoesIds: string[];
  setAllTalhoesIds: (
    value: string[] | ((prev: string[]) => string[])
  ) => void;

  talhaoIds: TalhaoStore[];
  setTalhaoIds: (
    value: TalhaoStore[] | ((prev: TalhaoStore[]) => TalhaoStore[])
  ) => void;

  planoOperacionalIds: TalhaoStore[];
  setPlanoOperacionalIds: (
    value: TalhaoStore[] | ((prev: TalhaoStore[]) => TalhaoStore[])
  ) => void;
}

const useTalhoesStore = create<TalhaoState>((set) => ({
  allTalhoesIds: [],
  setAllTalhoesIds: (value) =>
    set((state) => ({
      allTalhoesIds:
        typeof value === "function"
          ? value(state.allTalhoesIds)
          : value,
    })),

  talhaoIds: [],
  setTalhaoIds: (value) =>
    set((state) => ({
      talhaoIds:
        typeof value === "function"
          ? value(state.talhaoIds)
          : value,
    })),

  planoOperacionalIds: [],
  setPlanoOperacionalIds: (value) =>
    set((state) => ({
      planoOperacionalIds:
        typeof value === "function"
          ? value(state.planoOperacionalIds)
          : value,
    })),
}));

export default useTalhoesStore;
